export const useLayout = defineStore('layout', () => {
  /**
   * @param isShowTopBarBanner 네비게이션 상단 이벤트 띠배너 노출여부
   * @param hasTopBarBannerLayout 띠배너 노출용 레이아웃 여부
   */
  const isShowTopBarBanner = useRuntimeConfig().public?.showBanner === 'true' // 추후 API 연동으로 변경
  const hasTopBarBannerLayout = computed<boolean>(() => {
    return isShowTopBarBanner && !useRoute().params.partner
  })

  return {
    isShowTopBarBanner,
    hasTopBarBannerLayout
  }
})
